import get from "./get";

/**
 * Remove the given keys from the given object
 *
 * @param {any} object
 * @param {string[]} keys
 * @returns {any}
 */
export default function unset(object: object, keys: string[]): any {
    const newObject: any = { ...object };

    for (const key of keys) {
        const keyPath = key.split(".");

        if (keyPath.length === 1) {
            delete newObject[key];
        } else {
            const lastKey = keyPath.pop() as string;

            const parent = get(object, keyPath.join("."));

            delete parent[lastKey];
        }
    }

    return newObject;
}
